import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { PlusIcon } from 'lucide-react';
import { SectionHeading } from './ui/SectionHeading';
const faqs = [{
  q: '¿Sirve si soy principiante?',
  a: 'Sí. Va de diagnóstico básico hasta corrección avanzada.'
}, {
  q: '¿Cómo lo recibo?',
  a: 'Por email en menos de 5 minutos. 100% digital.'
}, {
  q: '¿Es obligatorio el PRO?',
  a: 'No. El pack base ya es completo. El PRO es para escalar.'
}, {
  q: '¿La garantía es real?',
  a: 'Sí. 7 días. 100%. Sin preguntas.'
}];
export function Faq() {
  const [open, setOpen] = useState<number | null>(0);
  return <section aria-label="Preguntas frecuentes" className="border-b border-ink-700 bg-ink-950 py-16 sm:py-20" data-id="element-40" data-mp="240ff06zvtjyj">
      <div className="mx-auto w-full max-w-page px-5 sm:px-8" data-id="element-41" data-mp="sn3cq0jrt9eh">
        <SectionHeading label="FAQ rápido" title="❓ Lo que siempre preguntan" data-id="element-42" data-mp="soeiu70out8r" />

        <ul className="mt-10 divide-y divide-ink-700 border-y border-ink-700" data-id="element-43" data-mp="nn8q497135z8">
          {faqs.map((faq, i) => {
          const isOpen = open === i;
          return <li key={faq.q} data-id="element-44" data-mp="uhane2jpz4vf" data-mpi={i}>
                <button type="button" onClick={() => setOpen(isOpen ? null : i)} aria-expanded={isOpen} className="flex w-full items-center justify-between gap-6 py-5 text-left transition-colors hover:text-ice focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ice" data-id="element-45" data-mp="ugitcw5rtf79">
                  <span className="display text-base text-bone sm:text-lg" data-id="element-46" data-mp="bj8506log66l">{faq.q}</span>
                  <PlusIcon className={`h-5 w-5 shrink-0 text-ash transition-transform duration-300 ${isOpen ? 'rotate-45 text-ice' : ''}`} aria-hidden="true" data-id="element-47" data-mp="3szfworz9dgdf" />
                </button>
                <AnimatePresence initial={false} data-id="element-48" data-mp="3nzbnln0ojnx8">
                  {isOpen ? <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.28,
                ease: 'easeOut'
              }} className="overflow-hidden" data-id="element-49" data-mp="1ugulht0pw5oz">
                      <p className="pb-6 pr-10 text-sm leading-relaxed text-ash sm:text-base" data-id="element-50" data-mp="1ft9idz3ue6h2">
                        {faq.a}
                      </p>
                    </motion.div> : null}
                </AnimatePresence>
              </li>;
        })}
        </ul>
      </div>
    </section>;
}